module.exports = "<div id=\"{{$ctrl.cbName}}\" >\r\n  <div uib-carousel active=\"$ctrl.active\" interval=\"$ctrl.myInterval\">\r\n    <div uib-slide ng-repeat=\"item in $ctrl.cbItems\" index=\"$index\">\r\n      <a href=\"{{item.url ? item.url : '#'}}\"\r\n         title=\"{{item.title}}\">\r\n        <img ng-src=\"{{item.imageUrl}}\"\r\n             target=\"{{item.url ? '_blank': '_self'}}\" class=\"img-responsive\">\r\n      </a>\r\n      <div class=\"carousel-caption\">\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/carousel-banner/templates/carousel-banner-base.view.html
 ** module id = 100
 ** module chunks = 0
 **/